/*
 * @Author: libo 
 * @Date: 2020-11-20 15:16:43 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-03-10 17:07:07
 */

<!-- 抄表异常处理查询 -->
<template>
<a-row :gutter="24">
  <a-col :md="collapsed?0: 5" :sm="24">
    <a-card :bordered="false">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
          <!-- 树-->
          <a-col :md="24" :sm="24">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px">
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表类型')">
                  <!--
                  <a-select v-model="queryParam.mtCode" placeholder="请输入表类型">
                    <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                      {{data.mtCode}}
                    </a-select-option>
                  </a-select>
                  -->
                  <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请选择表类型')" dictCode="meter_type" />
                </a-form-item>
              </a-col>
              <a-col :xl="12" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('最新告警时间')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    @change="onDateRangeChange"
                    @ok="onOk"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('处理状态')">
                  <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                    <a-select-option :value="0">
                      {{ $t('未处理') }}
                    </a-select-option>
                    <a-select-option :value="1">
                      {{ $t('处理中') }}
                    </a-select-option>
                    <a-select-option :value="2">
                      {{ $t('已处理') }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('故障类型')">
                  <a-select v-model="queryParam.meterWarnType" :placeholder="$t('请选择故障类型')">
                    <a-select-option v-for="(val,key) in meterWarnTypeObj" :value="key" :key="key">
                      {{ $t(meterWarnTypeObj[key]) }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button type="primary" icon="download" @click="handleExportXls($t('异常状态'))">{{ $t('导出') }}</a-button>

        <a-button v-if="selectedRowKeys.length > 0" style="margin-left: 8px" type="primary" @click="batchDeal"> {{ $t('批量处理') }}</a-button>
        <!--
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>

        -->
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        </div>
        <a-table
          ref="table"
          size="middle"
          tableLayout="fixed"
          bordered
          :scroll="{x: true}"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          :components="drag(columns)"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll,getCheckboxProps:getCheckboxProps}"
          @change="handleTableChange">
          <span slot="meterDealDescriptionSlot" slot-scope="text, record" :title="record.meterDealStatus ==1?record.meterDealDescription1:record.meterDealStatus ==2?record.meterDealDescription2:record.meterDealDescription0">
            {{record.meterDealStatus ==1?record.meterDealDescription1:record.meterDealStatus ==2?record.meterDealDescription2:record.meterDealDescription0}}
          </span>
          <span slot="meterDealStatus" slot-scope="text, record">
            <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
            <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
            <label v-else class="wait-status">{{ $t('未处理') }}</label>
          </span>
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="readingAbnormal(record)" :disabled ="record.meterDealStatus == 2">{{ $t('处理') }}</a>
            <a @click="handleDetail(record)" >{{ $t('详情') }}</a>
          </span>
        </a-table>
      </div>
      <meter-readingAbnormal-last-modal ref="readingAbnormalLastModal" @ok="modalFormOk"></meter-readingAbnormal-last-modal>
      <meter-readingAbnormal-last-detail-modal ref="modalForm" @ok="modalFormOk"></meter-readingAbnormal-last-detail-modal>
    </a-card>
  </a-col>
</a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { listSize } from '@/utils/util'
  import { getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import {isUndefined,isEmptyObject} from'@/utils/validate'
  import MeterReadingAbnormalLastModal from './modules/MeterReadingAbnormalLastModal'
  import MeterReadingAbnormalLastDetailModal from './modules/MeterReadingAbnormalLastDetailModal'
  import {meterTypeObj,meterWarnTypeObj} from '@/utils/constants/commonConstant'
  import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil';
  import TableDragResize  from '@/mixins/TableDragResize'

  import moment from 'moment'
  export default {
    name: 'MeterReadingAbnormalList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeterReadingAbnormalLastModal,
      MeterReadingAbnormalLastDetailModal
    },
    data () {
      return {
        meterTypeObj,
        date:[],
        meterWarnTypeObj,
        userTypeList:[],  //表类型
        description: 'meter_up_fault_record管理页面',
        collapsed: false,
        url: {
          list: "/jeecg-charge/meter/meterUpDataFaultLastRecord/list",
          delete: "/jeecg-charge/meter/meterUpDataFaultLastRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUpDataFaultLastRecord/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUserinfo/importExcel",
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
        },
        dictOptions:{},
        disableMixinCreated: true,
        currentNodeKey: ''
      }
    },
    activated() {
      // 只有组件被keep-alive包裹才会触发改方法，由于改页面未使用缓存故将获取跳转参数放置在created中
      console.log("执行activated");
      //获取首页跳转传递的参数
      this.getParams();
    },
    created() {
      console.log("页面创建")
      
      //this.queryUserTypeList()
    },
    mounted() {
      this.loadTree();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表类型'),
            align:"center",
            // dataIndex: 'meterType',
            dataIndex: 'mtName',
            width:100,
            ellipsis: true
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户手机号'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true
          },{
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('故障类型'),
            align:"center",
            dataIndex: 'meterWarnType',
            width:150,
            ellipsis: true,
            customRender: (t,r,index) => {
              let data = meterWarnTypeObj
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            },
          },
          {
            title: this.$t('本轮告警次数'),
            align:"center",
            dataIndex: 'meterEpicyclicWarnTimes',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('总告警次数'),
            align:"center",
            dataIndex: 'meterTotalWarnTimes',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('最新告警时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('本轮告警起始时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'meterDealTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('处理人'),
            align:"center",
            dataIndex: 'meterDealBy',
            width:100,
            ellipsis: true
          },

          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }

        ]
      },
    },
    methods: {
      getParams () {
        let routerParams = JSON.parse(JSON.stringify(this.$route.params));

        if(!isEmptyObject(routerParams)) {
          this.queryParam = this.$options.data.call(this).queryParam;
          this.queryParam = Object.assign(this.queryParam,routerParams);
          
          if(this.queryParam.areaSelected) {
            // 首页跳转的时候会携带当前选择区域
            this.currSelected = Object.assign({id:routerParams.areaSelected.key+'', areaName:routerParams.areaSelected.title},routerParams.areaSelected)
            this.currentNodeKey = this.currSelected.key+''
            this.$nextTick(()=> {
              this.$refs.areaTree.setCheckedKeys([this.currentNodeKey])
            })
            delete this.queryParam['areaSelected']
          }
        }
        this.loadData(true);
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      readingAbnormal(record) {   //处理异常界面点击跳转
        this.$refs.readingAbnormalLastModal.edit(record)
        this.$refs.readingAbnormalLastModal.title = this.$t('处理异常')
      },
      handleDetail:function(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title=this.$t("详情");
        this.$refs.modalForm.disableSubmit = true;
      },
      queryUserTypeList() {   //表类型请求
        let params = {pageNo: 1,pageSize: listSize}
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;
          }
        }) 
      },
      getCheckboxProps(record) {
        let props = {
          disabled: record.meterDealStatus == 2,
          meterDealStatus: record.meterDealStatus
        }
        return {props: {...props}};
      },
      modalFormOk() {
        // 新增/修改 成功时，重载列表
        this.selectionRows = [];
        this.selectedRowKeys = [];
        this.loadData();
      },
      batchDeal() {
        // 批量处理告警
        if(this.selectionRows.length<1){
          this.$message.error(this.$t("请先选择需要批量处理的表号"))
          return
        }else{
          let idList = []
          let meterIdList = []
          let meterDealStatus = ''
          let meterWarnType = ''
          console.log(this.selectionRows)
          for(let i = 0;i<this.selectionRows.length;i++) {
            if(i === 0) {
              meterDealStatus = this.selectionRows[0].meterDealStatus
              meterWarnType = this.selectionRows[0].meterWarnType
            }else{
              if(meterDealStatus !== this.selectionRows[i].meterDealStatus) {
                this.$message.error(this.$t("选择批量处理的处理进度不一致不能操作，请重新选择同一处理进度的表具"))
                return
              }
              if(meterWarnType !== this.selectionRows[i].meterWarnType) {
                this.$message.error(this.$t("选择批量处理的故障类型不一致不能操作，请重新选择同一故障类型的表具"))
                return
              }
            }
            idList.push(this.selectionRows[i].id)
            meterIdList.push(this.selectionRows[i].meterId)
          }
          let record = {}
          record.idList = idList.join(',')
          record.meterIdList = meterIdList.join(',')
          record.meterDealStatus = meterDealStatus
          record.meterWarnType = meterWarnType
          console.log(record)
          this.readingAbnormal(record)
        }
      },
      searchReset() { 
        this.date=[];
        this.queryParam = {}
        this.resetAareaData()
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .background{
    background-color:rgb(238,238,238)
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>
<style scoped>
  .table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table{
    border-right: 1px solid #e8e8e8;
  }

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border:1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}

</style>